import { render, staticRenderFns } from "./treeSelect.vue?vue&type=template&id=873dc5da&scoped=true&"
import script from "./treeSelect.vue?vue&type=script&lang=js&"
export * from "./treeSelect.vue?vue&type=script&lang=js&"
import style0 from "./treeSelect.vue?vue&type=style&index=0&id=873dc5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873dc5da",
  null
  
)

export default component.exports